const endpoints = {
  CCP_GET_CONVERSATIONS: '/v2/ccp/me/getConversations',
  CCP_GET_INTERACTIONS: '/v2/ccp/me/getInteractions',
  CCP_DETACH_CONVERSATION: '/v2/ccp/detachConversation',
  GET_TIMEZONE: '/v2/location/getTimezone',
  CCP_SEND_NOTIFICATION: '/v2/ccp/actions/sendSystemMessage',
  CCP_GET_USERDATA: '/v2/ccp/userData/getUserData',
  CCP_USER_UPDATE: '/v2/ccp/userData/update',
  CCP_GET_USERS_INFO: '/v2/ccp/external/getUsersInfo',
  CCP_GET_CLASSIFIERS: '/v2/ccp/external/getClassifiers',
  CCP_BLOCK_USER: '/v2/ccp/actions/contactBlock',
  GET_MESSAGES_BETWEEN: '/v2/message/getMessagesBetween',
  CCP_LIKE_USER: '/v2/ccp/actions/likeUser',
  CCP_REQUEST_PHOTO: '/v2/ccp/actions/requestPhoto',
  CCP_GET_CREDITS: '/v2/ccp/external/getCredits',
  CCP_SEND_CONTACT_INFO_NOTIFICATION: '/v2/ccp/conversation/sendContactInfoNotification',
}

export class Chat {

  constructor({ requester }) {
    this.requester = requester
    this.endpoints = endpoints
  }

  async fetchConversations(opts) {
    return this.requester.get(endpoints.CCP_GET_CONVERSATIONS,  {}, opts)
  }

  async fetchInteractions(params, opts) {
    return this.requester.get(endpoints.CCP_GET_INTERACTIONS, params, opts)
  }

  async detachConversations({ conversationUids, manual = false }, opts = {}) {
    return this.requester.post(endpoints.CCP_DETACH_CONVERSATION, { conversationUids, manual }, opts)
  }

  async detachConversation({ conversationUid, manual = false }, opts = {}) {
    return this.requester.post(endpoints.CCP_DETACH_CONVERSATION, { conversationUids: [conversationUid], manual }, opts)
  }

  async getTimezone({ country, state, city }, opts) {
    return this.requester.get(endpoints.GET_TIMEZONE, { country, state, city }, opts)
  }

  async sendNotification({ senderUid, receiverUid }, message, type = 'warning', opts = {}) {
    return this.requester.post(endpoints.CCP_SEND_NOTIFICATION, {
      senderUid,
      receiverUid,
      message,
      type,
    }, opts)
  }

  async getUserData(userUid, opts) {
    return this.requester.get(endpoints.CCP_GET_USERDATA, { userUid }, opts)
  }

  async updateUserData(userUid, data, opts = {}) {
    return this.requester.post(endpoints.CCP_USER_UPDATE, { userUid, data }, opts)
  }

  async getUsersInfo({ userUid, apUid }, opts) {
    return this.requester.get(endpoints.CCP_GET_USERS_INFO, { userUid, apUid }, opts)
  }

  async getClassifiers(params, opts) {
    return this.requester.get(endpoints.CCP_GET_CLASSIFIERS, params, opts)
  }

  async blockUser(userUid, blocked = true, opts = {}) {
    return this.requester.post(endpoints.CCP_BLOCK_USER, { userUid, blocked }, opts)
  }

  async getMessagesBetween({ conversationUid, before, after }, opts = {}) {
    return this.requester.get(endpoints.GET_MESSAGES_BETWEEN, { conversationUid, before, after }, opts)
  }

  async likeUser({ meUid, otherUid }, opts = {}) {
    return this.requester.post(endpoints.CCP_LIKE_USER, { apUid: meUid, userUid: otherUid }, opts)
  }

  async requestPhoto({ meUid, otherUid }, opts = {}) {
    return this.requester.post(endpoints.CCP_REQUEST_PHOTO, { apUid: meUid, userUid: otherUid }, opts)
  }

  async getCredits({ conversationUid }, opts = {}) {
    return this.requester.get(endpoints.CCP_GET_CREDITS, { conversationUid }, opts)
  }

  async sendContactInfoNotification(conversationId, opts) {
    return this.requester.post(endpoints.CCP_SEND_CONTACT_INFO_NOTIFICATION, { conversationId }, opts)
  }
}
